import { PayStatement } from "@wingspanhq/wingspan-api-sdk";

import { PaystubSummary } from "../types";
import { parsePayrollAmount } from "../utils";

/**
 * Adapt a v3 `PayStatement` into a paystub table row.
 *
 * TODO(v3): `employeeName` needs a Payee/Account join the flat pay-statement
 * read doesn't provide (no `expand`), so we fall back to the paystub number /
 * payee account id until a projection or bulk name lookup exists.
 */
export const selectorPaystubSummary = (
  payStatement: PayStatement
): PaystubSummary => ({
  id: payStatement.id ?? "",
  employeeName:
    payStatement.payStatementNumber ??
    payStatement.payeeAccountId ??
    "Unknown employee",
  employeeId: payStatement.payeeAccountId ?? "",
  workLogNumbers: (payStatement.earnings ?? [])
    .map(earning => earning.workLogId)
    .filter((id): id is string => !!id),
  netAmount: parsePayrollAmount(payStatement.amountDetails?.netPay),
  grossAmount: parsePayrollAmount(payStatement.amountDetails?.grossPay)
});
